import * as React from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";

import fertilitaSvg from "../images/icona_fertilita.svg";
// import odontoiatriaSvg from "../images/icona_odontoiatria.svg";
import rinoplasticaSvg from "../images/icona_rinoplastica.svg";
// import bariatricaSvg from "../images/icona_bariatrica.svg";
import trapiantoSvg from "../images/icona_trapianto.svg";

import chatSvg from "../images/chat_icon.svg";
import homeSvg from "../images/home_icon.svg";
import worldSvg from "../images/world_icon.svg";

import handsSvg from "../images/hands_icon.svg";
import heartSvg from "../images/heart_icon.svg";
import ribbonSvg from "../images/ribbon_icon.svg";

import Layout from "../components/layout";
import SEO from "../components/seo";
import NewsletterBanner from "../components/newsletterBanner";
import DestinationsRow from "../components/destinationsRow";

const query = graphql`
  query {
    destinations: allStrapiPage(filter: { sezione: { eq: "destinazioni" } }) {
      nodes {
        id
        anteprima_testo
        Titolo
        Permalink
        Contenuto
        contenuto
        categoria {
          Name
        }
        publication_date
        posizione_copertina
        Copertina {
          alternativeText
          localFile {
            absolutePath
            childImageSharp {
              gatsbyImageData(
                layout: FULL_WIDTH
                quality: 90
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
    }
  }
`;

const IndexPage = () => {
  const data = useStaticQuery(query);

  return (
    <Layout>
      <SEO title="Perché all'estero - Sterea Medicina e Viaggi" />

      <div className="sterea-center-column-wrapper overflow-hidden relative">
        <div className="color-overlay absolute w-full h-full bg-sterea-dark-blue bg-opacity-40 z-20"></div>

        <StaticImage
          src="../images/copertina_perche_all_estero.jpg"
          style={{ position: "absolute" }}
          className="w-full h-full z-10"
          objectFit="cover"
          alt="Foto di un viaggiatore seduto in un aeroporto"
        />

        <div className="sterea-center-column h-3/4-screen z-20 flex justify-center items-center">
          <h1 className="w-11/12 text-white text-3xl lg:text-4xl leading-normal text-center font-bold">
            Perché all'estero
          </h1>
        </div>
      </div>

      <div className="sterea-center-column-wrapper">
        <div className="sterea-center-column px-min flex flex-col items-center">
          <div className="sterea-content-container pt-12 lg:w-full">
            <p>
              In un mondo globalizzato come il nostro, la disponibilità sempre
              maggiore di informazioni sul web, il costo sempre minore del
              trasporto aereo, hanno reso alla portata di tutti cure e
              trattamenti prima considerati inaccessibili. Oggi come mai prima
              d'ora, si cerca la soluzione all’estero, decidendo di viaggiare in
              Paesi che offrono medici specializzati e tecnologie
              all'avanguardia a prezzi decisamente inferiori rispetto
              all'Italia, magari con il bonus di una vacanza.
            </p>
            <p>
              In considerazione di tutto questo, con l'obiettivo di offrire un
              servizio che risponda alle esigenze ed aspettative dei nostri
              clienti, per le nostre scelte ci siamo basati su tre aspetti
              fondamentali:
            </p>
          </div>
          <div className="sterea-content-container lg:w-3/4 py-lg">
            <div className="flex items-center mb-6">
              <div className="mr-12">
                <svg
                  width="71"
                  height="71"
                  viewBox="0 0 54 71"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.9999 62.6797C26.4214 62.6797 25.9524 63.1453 25.9524 63.7197C25.9524 64.2941 26.4214 64.7598 26.9999 64.7598C27.5784 64.7598 28.0474 64.2941 28.0474 63.7197C28.0474 63.1453 27.5784 62.6797 26.9999 62.6797ZM26.9999 56.4395C26.4214 56.4395 25.9524 56.9051 25.9524 57.4795C25.9524 58.0539 26.4214 58.5195 26.9999 58.5195C27.5784 58.5195 28.0474 58.0539 28.0474 57.4795C28.0474 56.9051 27.5784 56.4395 26.9999 56.4395ZM26.9999 68.9199C26.4214 68.9199 25.9524 69.3856 25.9524 69.96C25.9524 70.5343 26.4214 71 26.9999 71C27.5784 71 28.0474 70.5343 28.0474 69.96C28.0474 69.3856 27.5784 68.9199 26.9999 68.9199ZM47.5785 47.5828L42.9159 46.0249C45.4934 44.2021 47.1089 41.2104 47.1089 37.981C47.1156 37.9677 47.1089 19.9661 47.1089 19.9661C47.1089 14.6347 45.0174 9.62105 41.2197 5.8489C37.4212 2.07717 32.3712 0 26.9999 0C23.5499 0 20.1461 0.882369 17.1563 2.55184C16.6521 2.83334 16.4732 3.46749 16.7567 3.9681C17.0403 4.46884 17.6791 4.6462 18.1831 4.36484C20.8601 2.87023 23.9089 2.08008 26.9999 2.08008C31.8115 2.08008 36.3354 3.94078 39.7382 7.31938C43.1403 10.6987 45.0139 15.19 45.0139 19.966V19.9707C44.4056 19.624 43.7016 19.4246 42.9514 19.4246H41.9448C39.1423 18.9467 36.3935 18.1581 33.7737 17.0786C31.7798 16.2569 29.8423 15.2586 28.0149 14.1115C27.3749 13.7097 26.54 13.747 25.9374 14.2043C24.5118 15.2855 22.9724 16.2206 21.3616 16.9833C18.4676 18.3536 15.3535 19.1747 12.1053 19.4246H11.0486C10.2984 19.4246 9.59444 19.624 8.98606 19.9707V19.966C8.98606 15.1266 10.9017 10.5938 14.3802 7.20276C14.7931 6.80033 14.7991 6.14192 14.3938 5.732C13.9886 5.32223 13.3253 5.31599 12.9125 5.71855C9.02949 9.50388 6.89108 14.5639 6.89108 19.966V37.9808C6.89108 41.2102 8.50659 44.2021 11.0841 46.0248L6.42138 47.5828C2.58059 48.8663 0 52.4317 0 56.4547V69.96C0 70.5343 0.468996 71 1.04749 71C1.62598 71 2.09498 70.5343 2.09498 69.96V56.4547C2.09498 53.3257 4.10225 50.5526 7.08968 49.5543L8.91008 48.946C8.64067 50.0453 8.52153 51.1784 8.56343 52.3001C8.6031 53.3651 8.7841 54.4119 9.09737 55.4271C7.06259 56.0337 5.57543 57.9096 5.57543 60.1249V64.3576C5.57543 65.4047 6.4334 66.2564 7.48787 66.2564H8.66175C9.24025 66.2564 9.70924 65.7908 9.70924 65.2164C9.70924 64.642 9.24025 64.1764 8.66175 64.1764H7.67027V60.1248C7.67027 58.5679 8.94541 57.3013 10.5132 57.3003L10.5155 57.3005L10.518 57.3003C12.0854 57.302 13.36 58.5683 13.36 60.1248V64.1764H12.3686C11.7901 64.1764 11.3211 64.642 11.3211 65.2164C11.3211 65.7908 11.7901 66.2564 12.3686 66.2564H13.5425C14.597 66.2564 15.4549 65.4046 15.4549 64.3576V60.1249C15.4549 57.6693 13.628 55.6297 11.2528 55.2752C10.8974 54.2907 10.6957 53.2672 10.6567 52.2231C10.6052 50.8386 10.8486 49.4321 11.3612 48.127L18.5066 45.7395L26.004 53.1834C26.6164 53.7973 27.6608 53.8002 28.2755 53.1834L30.3446 51.129C30.7537 50.7228 30.7537 50.0643 30.3446 49.6583C29.9356 49.2521 29.2723 49.2521 28.8633 49.6583L27.1396 51.3693L20.4998 44.7767C21.4843 43.9269 21.9329 42.6316 21.8323 41.3246C23.4367 41.8801 25.1561 42.1851 26.9439 42.1913C28.7459 42.1976 30.5104 41.9057 32.1675 41.3417C31.9965 42.6681 32.6153 44.1115 33.6547 44.9006L32.3127 46.2331C31.9036 46.6392 31.9036 47.2978 32.3127 47.7038C32.7217 48.11 33.385 48.11 33.7939 47.7038L35.7022 45.8091L42.0811 47.9405C42.5635 49.1586 42.8125 50.4761 42.8001 51.7799C42.7888 52.962 42.5614 54.1557 42.1421 55.2685C39.4191 55.6224 37.3092 57.9395 37.3092 60.7381C37.3092 63.7809 39.8023 66.2563 42.8669 66.2563C45.9314 66.2563 48.4246 63.781 48.4246 60.7383C48.4246 58.191 46.6768 56.0423 44.3098 55.4098C44.6827 54.2428 44.8835 53.0161 44.8951 51.7998C44.9049 50.7815 44.7822 49.7562 44.5371 48.7611L46.9103 49.554C49.8979 50.5524 51.905 53.3256 51.905 56.4546V69.9598C51.905 70.5342 52.374 70.9999 52.9525 70.9999C53.531 70.9999 54 70.5342 54 69.9598V56.4546C54 52.4317 51.4194 48.8664 47.5785 47.5828ZM42.8976 21.5047H42.9514C44.0861 21.5047 45.0095 22.4194 45.0139 23.545V23.5609C45.0089 24.7016 44.0517 25.6339 42.8976 25.6012V21.5047ZM8.98592 23.5451C8.98927 22.4037 9.94947 21.4726 11.1023 21.5048V25.6015C9.94821 25.6331 8.9908 24.7045 8.98592 23.5612V23.5451ZM19.7373 41.8886C19.7373 42.634 19.26 43.2938 18.5485 43.5308L13.7428 45.1366C10.8834 43.9213 8.98606 41.0906 8.98606 37.981V27.1356C9.64332 27.5128 10.3697 27.6944 11.1676 27.6817C11.665 33.2326 15.0174 37.9806 19.7373 40.4255V41.8886ZM26.951 40.1113C19.3672 40.0852 13.1972 33.8656 13.1972 26.2468V21.4125C16.3681 21.0668 19.4136 20.21 22.2635 18.8608C23.948 18.0633 25.56 17.0914 27.0579 15.9711C28.9378 17.1386 30.9262 18.1573 32.9706 18.9997C35.4884 20.0374 38.1191 20.821 40.8025 21.3334V26.4069C40.8025 30.0764 39.3607 33.5238 36.7428 36.1142C34.0804 38.7487 30.7547 40.1244 26.951 40.1113ZM40.2572 45.1364L35.4504 43.5303C34.7399 43.2938 34.2625 42.634 34.2625 41.8886V40.4557C35.7047 39.7188 37.0396 38.7573 38.2217 37.5876C40.9318 34.9061 42.5468 31.4269 42.8461 27.6814C43.6163 27.6924 44.3831 27.4993 45.0141 27.1353V37.9807C45.0139 41.0904 43.1166 43.9213 40.2572 45.1364ZM46.3296 60.7383C46.3296 62.6341 44.7762 64.1764 42.867 64.1764C40.9576 64.1764 39.4043 62.6341 39.4043 60.7383C39.4043 58.8439 40.9556 57.3025 42.863 57.3003L42.8663 57.3005L42.8692 57.3003C44.7775 57.3014 46.3296 58.8432 46.3296 60.7383Z"
                    fill="#212D51"
                  />
                </svg>
              </div>
              <p>
                Specialisti di grande professionalità con formazione
                internazionale, pronti a offrire le soluzioni più efficaci per
                ottenere il miglior risultato possibile. Selezionati in base
                alla loro esperienza, al numero degli interventi svolti, ai
                risultati ottenuti.
              </p>
            </div>
            <div className="flex items-center mb-6">
              <div className="mr-12">
                <svg
                  width="71"
                  height="71"
                  viewBox="0 0 48 65"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M35.6539 39.0336L34.4547 40.0174L35.6708 40.9801L46.7194 49.7266C46.7325 49.7425 46.7398 49.759 46.7446 49.7802C46.7526 49.8152 46.7537 49.8697 46.7339 49.9333C46.6915 50.0693 46.6076 50.1181 46.5442 50.1284L46.5251 50.1315L46.5061 50.1352L40.1319 51.3741L39.3139 51.5331L39.146 52.3494L37.8718 58.5456L37.8679 58.5648L37.8645 58.5841C37.8612 58.6031 37.8318 58.6968 37.6555 58.7489C37.4805 58.8006 37.3796 58.7437 37.3444 58.7073L37.3313 58.6939L37.3179 58.6808L31.2217 52.7555L29.1004 50.6937V53.6518V62.5676V62.5879L29.1011 62.6081C29.1015 62.6209 29.0971 62.7115 28.9388 62.7939C28.7813 62.876 28.6687 62.8423 28.6219 62.8099L28.6059 62.7988L28.5896 62.7882L23.181 59.2832L22.5012 58.8426L21.8214 59.2832L16.4127 62.7882L16.3961 62.799L16.3797 62.8104C16.3342 62.842 16.2217 62.8763 16.0634 62.7939C15.9046 62.7114 15.9008 62.6209 15.9012 62.6091L15.9019 62.5883V62.5676V43.5V42.624L15.0785 42.3251C7.0583 39.413 1.25 30.7625 1.25 21.8732C1.25 10.5358 10.7508 1.25 22.5012 1.25C34.2516 1.25 43.7524 10.5358 43.7524 21.8732V21.8735C43.7529 24.8642 43.0818 27.8203 41.7845 30.5354C40.4422 33.3448 37.9489 37.1508 35.6539 39.0336Z"
                    stroke="#1A2A58"
                    stroke-width="2.5"
                  />
                  <path
                    d="M22.5 8L25.7555 18.0193L36.2903 18.0193L27.7674 24.2115L31.0229 34.2307L22.5 28.0385L13.9771 34.2307L17.2326 24.2115L8.70968 18.0193L19.2445 18.0193L22.5 8Z"
                    stroke="#212D51"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M43.75 22C43.75 33.4336 34.2627 42.75 22.5 42.75C10.7373 42.75 1.25 33.4336 1.25 22C1.25 10.5664 10.7373 1.25 22.5 1.25C34.2627 1.25 43.75 10.5664 43.75 22Z"
                    stroke="#1A2A58"
                    stroke-width="2.5"
                  />
                </svg>
              </div>
              <p>
                Strutture moderne e confortevoli, dotate delle migliori
                attrezzature all'avanguardia, per garantire un’assistenza
                sanitaria di qualità ed in continuo miglioramento.
              </p>
            </div>
            <div className="flex items-center">
              <div className="mr-12">
                <svg
                  width="71"
                  height="71"
                  viewBox="0 0 66 66"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M24.3398 14.1757C24.3398 21.9921 30.7115 28.3518 38.5432 28.3518C46.375 28.3518 52.7466 21.9921 52.7466 14.1757C52.7466 6.35921 46.375 0 38.5432 0C30.7115 0 24.3398 6.35921 24.3398 14.1757ZM50.1645 14.1757C50.1645 20.5711 44.9512 25.7742 38.5432 25.7742C32.1353 25.7742 26.922 20.5711 26.922 14.1757C26.922 7.7807 32.1353 2.57762 38.5432 2.57762C44.9512 2.57762 50.1645 7.7807 50.1645 14.1757Z"
                      fill="#212D51"
                    />
                    <path
                      d="M14.9372 65.6188C15.4377 66.1224 16.2525 66.1279 16.7596 65.6294L23.0197 59.4741C24.0833 58.4127 24.4067 56.8411 23.939 55.475L25.2856 54.1789C26.0106 53.48 26.9651 53.0948 27.9742 53.0948H45.1396C48.185 53.0948 51.0633 51.9276 53.2453 49.8082C53.3351 49.7211 52.5637 50.628 64.9559 35.846C66.7939 33.6758 66.5189 30.4169 64.3424 28.5804C62.1795 26.7612 58.9394 27.0225 57.0964 29.1555L49.477 36.9714C48.5149 35.7896 47.0478 35.0529 45.4625 35.0529H31.0639C29.015 34.1974 26.841 33.7644 24.5979 33.7644C18.3801 33.7644 12.9509 36.6305 10.0373 42.0043C8.80977 41.7722 7.51516 42.1428 6.58381 43.0723L0.441208 49.2211C-0.06029 49.7231 -0.061299 50.5353 0.43919 51.0388L14.9372 65.6188ZM24.5974 36.3415C26.5751 36.3415 28.4873 36.7388 30.2819 37.5223C30.4453 37.5938 30.6214 37.6306 30.7995 37.6306H45.4625C46.8626 37.6306 48.0452 38.7701 48.0452 40.2077C48.0452 41.6292 46.8868 42.7853 45.4625 42.7853H34.9275C34.2146 42.7853 33.6365 43.3624 33.6365 44.0739C33.6365 44.7859 34.2146 45.3624 34.9275 45.3624H45.4625C48.3106 45.3624 50.6274 43.0502 50.6274 40.2077C50.6274 39.9811 50.6112 39.7565 50.582 39.534C57.9526 31.9723 58.9919 30.9098 59.0363 30.8569C59.9565 29.7728 61.5902 29.6354 62.6769 30.5498C63.7647 31.4677 63.9024 33.0972 62.9797 34.1874L51.3983 48.0055C49.7071 49.6259 47.4867 50.5177 45.1396 50.5177H27.9742C26.2921 50.5177 24.6998 51.1597 23.492 52.3244L22.3946 53.3813L12.2789 43.2858C14.6431 38.8592 19.0794 36.3415 24.5974 36.3415ZM8.4112 44.8936C8.83702 44.4686 9.49088 44.3921 10.01 44.7124C10.2335 44.8483 9.59179 44.2652 21.1939 55.8285C21.71 56.3436 21.6822 57.1644 21.2009 57.6448L15.864 62.8922L3.17675 50.133L8.4112 44.8936Z"
                      fill="#212D51"
                    />
                    <path
                      d="M41.3686 18.1087C41.3686 18.1087 41.3686 18.1087 41.3605 18.1087C39.9305 18.6612 38.3055 18.32 37.2249 17.2312C37.2087 17.215 37.1924 17.1825 37.1762 17.1825H40.6048C41.0517 17.1825 41.4173 16.8169 41.4173 16.37C41.4173 15.9231 41.0517 15.5575 40.6048 15.5575H36.2418C36.1524 15.265 36.1037 14.9644 36.0956 14.6638H41.0355C41.4823 14.6638 41.8479 14.2982 41.8479 13.8513C41.8479 13.4044 41.4823 13.0388 41.0355 13.0388H36.3881C36.5749 12.5595 36.8674 12.1207 37.233 11.7632C38.3136 10.6745 39.9386 10.3333 41.3686 10.8857C41.7911 11.0482 42.2623 10.837 42.4167 10.4145C42.5711 10.0001 42.3679 9.52889 41.9536 9.3664C39.9224 8.58641 37.623 9.0739 36.0874 10.6176C35.405 11.2839 34.9175 12.1207 34.6737 13.0469H33.8287C33.3819 13.0469 33.0162 13.4126 33.0162 13.8594C33.0162 14.3063 33.3819 14.6719 33.8287 14.6719H34.4787C34.495 14.9725 34.5275 15.2732 34.5843 15.5657H33.8125C33.3656 15.5657 33 15.9313 33 16.3781C33 16.825 33.3656 17.1906 33.8125 17.1906H35.1612C35.4131 17.6212 35.7218 18.0275 36.0712 18.385C37.6068 19.9287 39.9142 20.4162 41.9454 19.6281C42.3679 19.4656 42.5711 18.9943 42.4167 18.58C42.2542 18.1575 41.783 17.9544 41.3686 18.1087Z"
                      fill="#212D51"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="66" height="66" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p>
                Prezzi vantaggiosi con i quali offrire soluzioni personalizzate
                ad ogni nostro cliente. Garantiamo la combinazione tra l’ottima
                qualità del servizio con costi alla portata di tutti.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="sterea-center-column-wrapper py-12 px-min bg-sterea-yellow">
        <div className="sterea-center-column flex flex-col justify-center">
          <h2 className="text-center">Come funziona</h2>
          <div className="flex flex-wrap pt-12">
            <div className="w-full lg:w-1/3 mb-12 lg:mb-0 lg:px-3 flex flex-col items-center text-center">
              <img
                src={chatSvg}
                className="mb-6 h-16"
                alt="Icona di una chat, che rappresenta la fase di consultazione con Sterea"
              />
              <p>
                <span className="font-bold">1.</span> Decideremo insieme, in
                base alle vostre esigenze, quali trattamenti sono più adatti a
                voi.
              </p>
            </div>
            <div className="w-full lg:w-1/3 mb-12 lg:mb-0 lg:px-3 flex flex-col items-center text-center">
              <img
                src={worldSvg}
                className="mb-6 h-16"
                alt="Icona di un mondo, che rappresenta il viaggio all'estero con Sterea"
              />
              <p>
                <span className="font-bold">2.</span> Un assistente personale
                che parla italiano vi accoglierà in aeroporto, vi affiancherà
                costantemente per tutto il tempo che sarete in Clinica e nei
                momenti liberi, se necessario, per garantire un'esperienza
                all'estero senza preoccupazioni.
              </p>
            </div>
            <div className="w-full lg:w-1/3 lg:px-3 flex flex-col items-center text-center">
              <img
                src={homeSvg}
                className="mb-6 h-16"
                alt="Icon della casa, che rappresenta il ritorno a casa dopo l'intervento con Sterea"
              />
              <p>
                <span className="font-bold">3.</span> Restiamo in contatto
                telefonico e rimaniamo a vostra disposizione per qualsiasi
                aiuto.
              </p>
            </div>
          </div>
          {/* <div className="flex justify-center">
            <div className="sterea-blue-purple-button">Scopri di più</div>
          </div> */}
        </div>
      </div>

      <DestinationsRow destinations={data.destinations.nodes} />

      <NewsletterBanner />
    </Layout>
  );
};

export default IndexPage;
